import { Card, CardContent } from '@web/components/ui/card';
import { ContactCommentList } from '@web/routes/dashboard/chat/-components/comment-list';
import { Route } from '@web/routes/dashboard/admin/contact/route';

export default function Comments({ contactId }: { contactId: string }) {
  const { setActiveCommentId } = Route.useRouteContext();

  return (
    <Card className="overflow-hidden rounded-xl border-2 p-0 shadow-2xl">
      <CardContent className="p-2">
        <ContactCommentList
          contactId={contactId}
          setActiveCommentId={setActiveCommentId}
        />
      </CardContent>
    </Card>
  );
}
